import PropTypes from 'prop-types';

const FormattersConstants = {
  BOLD: 'bold',
  CYCLE_HEADER: 'cycle_header',
  LINK: 'link',
  INTERNAL_LINK: 'internalLink',
  ITALIC: 'italic',
  MONOSPACE: 'monospace',
  UNDERLINE: 'underline',
  STRIKETHROUGH: 'strikethrough',
  SUBSCRIPT: 'subscript',
  SUPERSCRIPT: 'superscript',
  SYMBOL: 'symbol',
  FOREGROUND_COLOR: 'foregroundColor' as const,
  BACKGROUND_COLOR: 'backgroundColor' as const,
  POINT_FORMATS: ['internalLink'],
  // Width of a point format chip as used by selutil to determine selections
  CHIP_WIDTH: 1,
  // Format option to set a link (without opening modal)
  SET_LINK: 'SET_LINK',
  DAY: 'day',
  SECTION: 'section',
  SEARCH_RESULT: 'searchResults' as const,
  PRECISION: 'precision' as const,
  IMPORTANT: 'important' as const,
  SCIENTIFIC_NOTATION: 'scientificNotation' as const,
  ALIGN: 'align' as const,
};

export interface FormatData {
  id?: string;
  name?: string;
  url?: string;
  color?: string;
}

export interface FormatPosition {
  start: number;
  end: number;
}

export interface FormatLink {
  start: number;
  end: number;
  data: {url: string};
}

export interface FormatInternalLink {
  position: number;
  data: {
    id: string;
    name: string;
    url: string;
    cachedDisplayInfo?: {displayLabel: string};
  };
}

export interface FormatColor {
  start: number;
  end: number;
  data: {color: string};
}

export interface Format {
  bold: Array<{}>;
  monospace: Array<FormatPosition>;
  italic: Array<FormatPosition>;
  underline: Array<FormatPosition>;
  subscript: Array<FormatPosition>;
  superscript: Array<FormatPosition>;
  link: Array<FormatLink>;
  internalLink: Array<FormatInternalLink>;
  foregroundColor: Array<FormatColor>;
  backgroundColor: Array<FormatColor>;
}

export type FormatStateMap = {
  [format in keyof Format]?: string | boolean | null;
};

export interface ExtendedFormat extends Format {
  searchResults?: Array<{start: number; end: number; data: {uuid: string; selected: boolean}}>;
}

export const formatType = PropTypes.shape({
  bold: PropTypes.arrayOf(
    PropTypes.shape({
      start: PropTypes.number.isRequired,
      end: PropTypes.number.isRequired,
    })
  ),
  italic: PropTypes.arrayOf(
    PropTypes.shape({
      start: PropTypes.number.isRequired,
      end: PropTypes.number.isRequired,
    })
  ),
  monospace: PropTypes.arrayOf(
    PropTypes.shape({
      start: PropTypes.number.isRequired,
      end: PropTypes.number.isRequired,
    })
  ),
  underline: PropTypes.arrayOf(
    PropTypes.shape({
      start: PropTypes.number.isRequired,
      end: PropTypes.number.isRequired,
    })
  ),
  subscript: PropTypes.arrayOf(
    PropTypes.shape({
      start: PropTypes.number.isRequired,
      end: PropTypes.number.isRequired,
    })
  ),
  superscript: PropTypes.arrayOf(
    PropTypes.shape({
      start: PropTypes.number.isRequired,
      end: PropTypes.number.isRequired,
    })
  ),
  link: PropTypes.arrayOf(
    PropTypes.shape({
      start: PropTypes.number.isRequired,
      end: PropTypes.number.isRequired,
      data: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }).isRequired,
    })
  ),
});

export default FormattersConstants;
